<template>
  <div>
    <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="500px"
    center
    destroy-on-close
    >
    <el-form ref="added" :model="formData" :rules="rules" size="medium" label-position="right" label-width="120px">
      <el-form-item label="审核结果：" prop="audit_status">
        <el-radio-group v-model="formData.audit_status">
          <el-radio :label="20">通过</el-radio>
          <el-radio :label="30">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="驳回原因：" prop="reject_reason" v-if="formData.audit_status == 30">
        <el-input type="textarea" style="width: 300px;" rows="4" :maxlength="120" show-word-limit
        v-model="formData.reject_reason" placeholder="请输入驳回原因"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button @click="save" type="primary">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    data() {
      return {
        dialogVisible: false,
        title: '',
        formData: { 
          audit_status: 20,
          reject_reason: ''
        },
        row: '',
        rules: {
          audit_status: [{
            required: true,
            message: '请选择状态',  
            trigger: 'change'
          }],
          reject_reason: [{
            required: true,
            message: '请输入驳回原因',  
            trigger: 'blur'
          }]
        },
      }
    },
    methods: {
      show(row){
        if(row){
          this.title = '招聘审核'
          this.row = row
          this.formData = {
            audit_status: 20,
            reject_reason: row.reject_reason || ''
          }
          this.dialogVisible = true
        }
      },
      save(formList){
        this.$refs['added'].validate(async valid => {
          if (valid) {
            if(this.row.id){
              userInfoAPI.updateRecruit(this.row.id, this.formData).then(({ data })=>{
                if (data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  this.dialogVisible = false
                  this.$emit('success')
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              })
            }
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  /deep/{
    .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }
      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
  }
</style>